import { useApi } from '@omnipresentgroup/api';
import { notifySuccess } from '@omnipresentgroup/design-system';
import type { RequestChangesTimesheetRequest } from '@omnipresentgroup/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useRequestChangesTimesheetMutation = (timesheetId: string) => {
  const { POST } = useApi();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: RequestChangesTimesheetRequest) => {
      return POST({
        path: `${API_BASE}/${API_PATH}/${timesheetId}/request-changes`,
        body: payload,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_PATH],
      });
      notifySuccess({
        title: 'Success',
        description:
          'The employee has been notified via email of the changes requested.',
      });
    },
  });
};
